import emitter from '@/mixins/emitter'
import { generateID } from '@/helpers/generateID'

export default {
  mixins: [emitter],
  data() {
    return {}
  },
  methods: {
    generateID,
    addUploadingTask(name, taskFunc, taskData, callback) {
      const id = generateID()
      this.dispatch(
        'GlobalUploadDialog',
        'add-uploading-task',
        { id, name, taskFunc, taskData, callback },
        'global-upload-dialog',
      )
      return id
    },
    failUploadingTask(id, errorMessage) {
      this.dispatch(
        'GlobalUploadDialog',
        'fail-uploading-task',
        { id, errorMessage },
        'global-upload-dialog',
      )
    },
    completeUploadingTask(id) {
      this.dispatch(
        'GlobalUploadDialog',
        'complete-uploading-task',
        { id },
        'global-upload-dialog',
      )
    },
  },
}
